import { Plant } from '@cemex-core/cmx-api';
import { OneClickPlantsActions, OneClickPlantsActionTypes } from '../actions/one-click-plants.actions';
import { OneClickProfileActions, OneClickProfileActionTypes } from '../actions/one-click-profile.actions';

export interface OneClickPlantsState {
  loading: boolean[];
  plantsAvailable: Plant[][];
  selected: Plant[];
}

export const initialState: OneClickPlantsState = {
  loading: [],
  plantsAvailable: [],
  selected: [],
};

export function reducer(
  state = initialState,
  action: OneClickPlantsActions | OneClickProfileActions,
): OneClickPlantsState {
  switch (action.type) {
    case OneClickPlantsActionTypes.LOAD_PLANTS: {
      state.loading[action.index] = true;
      return {
        ...state,
        loading: state.loading.map((item, index) => {
          if (index === action.index) {
            return true;
          } else {
            return item;
          }
        }),
      } as OneClickPlantsState;
    }
    case OneClickPlantsActionTypes.LOAD_PLANTS_COMPLETE: {
      state.loading[action.index] = true;
      state.plantsAvailable[action.index] = undefined;
      return {
        ...state,
        loading: state.loading.map((item, index) => {
          if (index === action.index) {
            return false;
          } else {
            return item;
          }
        }),
        plantsAvailable: state.plantsAvailable.map((item, index) => {
          if (index === action.index) {
            return [...action.payload];
          } else {
            return item;
          }
        }),
      } as OneClickPlantsState;
    }
    case OneClickPlantsActionTypes.SELECT_PLANTS: {
      state.selected[action.index] = undefined;
      return {
        ...state,
        selected: state.selected.map((item, index) => {
          if (index === action.index) {
            return action.payload;
          } else {
            return item;
          }
        }),
      } as OneClickPlantsState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickPlantsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
